import { SectionHeader } from '@/modules/Frontend/UiBlocks'

import { Skeleton, useProductViewSkeletonVariants } from '../../../../Theme'
import { findCustomAttributeValue } from '../../../lib'
import { useProductAttributes } from '../../../state'

export function PageTitle() {
  const { customAttributes, productName, loading } = useProductAttributes()
  const { skeletonSectionVariants } = useProductViewSkeletonVariants()
  const h2ProductName = findCustomAttributeValue(customAttributes, 'h2_product_name')

  if (loading) {
    return (
      <div className={skeletonSectionVariants({ section: 'pageTitle' })}>
        <Skeleton size="lg" width="full" />
        <Skeleton size="md" width="threeQuarters" />
      </div>
    )
  }

  return (
    <div className="flex flex-col justify-start gap-1 mb-3 xl:mb-5 bg-cards-bg">
      <SectionHeader as="h1" size="xl" className="font-semibold ">
        {productName}
      </SectionHeader>
      {h2ProductName && (
        <SectionHeader as="h2" size="xl" className="font-semibold">
          {h2ProductName}
        </SectionHeader>
      )}
    </div>
  )
}
